import { atom } from 'jotai';

export const isUpcomingSessionsListLoadingAtom = atom<boolean>(false);
export const isDraggingUpcomingSessionsTabAtom = atom<boolean>(false);
export const uploadAbortControllerAtom = atom<AbortController | null>(null);
